export default "__VITE_ASSET__CKRsd4gw__"